<template>
  <div class="bg-lightblue page">
    <header>
      <div class="container flex">
        <div class="page__logo">
          <img alt="Логотип" class="head-panel__logo" src="@/assets/img/logo/logo.png" />
          <div>Программа для стоматологических<br />клиник</div>
        </div>
        <removable-feature feature="registration">
          <router-link
            class="page__button"
            v-bind:to="{ name: 'Registration' }"
          >Регистрация</router-link>
        </removable-feature>
      </div>
    </header>
    <main>
      <div class="container">
        <h1>Политика конфиденциальности</h1>
        <div class="page__text">
          Настоящая Политика конфиденциальности персональной информации (далее — Политика) действует
          в отношении всей информации, которую ООО Айкомплекс (ИНН 4217170238 ОГРНИП
          1154217003049 от 12.05.2015 г, Адрес: 654007 Кемеровская область - Кузбасс,
          г. Новокузнецк, ул. Н.С. Ермакова, дом 11 , этаж 3, офис 5)
          (далее — Администрация Сайта) может получить о пользователе во время
          использования им сайта mis.32top.ru (далее - Сайт).
          Использование сайта mis.32top.ru означает
          безоговорочное согласие пользователя с настоящей Политикой и указанными в ней условиями
          обработки его персональной информации; в случае несогласия с этими условиями пользователь
          должен воздержаться от использования данного ресурса.
        </div>
        <ol class="page__text">
          <li>
            Персональная информация пользователей, которую получает и обрабатывает Администрация
            Сайта.
            <ol>
              <li>
                В рамках настоящей Политики под «персональной информацией пользователя» понимаются:
                <ol>
                  <li>
                    Персональная информация, которую пользователь предоставляет о себе
                    самостоятельно при оставлении заявки, регистрации (создании учётной записи) или
                    в ином процессе использования Сайта.
                  </li>
                  <li>
                    Данные, которые автоматически передаются Сайтом в процессе его использования с
                    помощью установленного на устройстве пользователя программного обеспечения, в
                    том числе IP-адрес, информация из cookie, информация о браузере пользователя
                    (или иной программе, с помощью которой осуществляется доступ к Сайту), время
                    доступа, адрес запрашиваемой страницы.
                  </li>
                  <li>
                    Данные, которые предоставляются Администрации Сайта, в целях осуществления
                    оказания услуг и/или предоставления иных ценностей для посетителей Сайта, в
                    соответствии с деятельностью настоящего ресурса: &nbsp; <br />имя
                    <br />электронная почта <br />номер телефона <br />месторасположение
                    <br />фотография
                  </li>
                </ol>
              </li>
              <li>
                Настоящая Политика применима только к Cайту и не контролирует и не несет
                ответственность за Сайты третьих лиц, на которые пользователь может перейти по
                ссылкам, доступным на Cайте. На таких Сайтах у пользователя может собираться или
                запрашиваться иная персональная информация, а также могут совершаться иные действия.
              </li>
              <li>
                Сайт в общем случае не проверяет достоверность персональной информации,
                предоставляемой пользователями, и не осуществляет контроль за их дееспособностью.
                Однако Сайт исходит из того, что пользователь предоставляет достоверную и
                достаточную персональную информацию по вопросам, предлагаемым в формах настоящего
                ресурса, и поддерживает эту информацию в актуальном состоянии.
              </li>
              <li>
                Предоставляя свои персональные данные при регистрации на Сайте, пользователь даёт
                Администрации Сайта своё согласие на обработку и использование своих персональных
                данных согласно ФЗ № 152-ФЗ «О персональных данных» от 27.07.2006 г. различными
                способами в целях, указанных в п. 2 данной Политики.
              </li>
            </ol>
          </li>
          <li>
            Цели сбора и обработки персональной информации пользователей
            <ol>
              <li>
                Персональную информацию пользователя Администрация Сайта использует в следующих
                целях:
              </li>
              <ol>
                <li>
                  Предоставление пользователю персонализированных услуг и сервисов и иных ценностей.
                </li>
                <li>
                  Связь с пользователем, в том числе направление уведомлений, запросов и информации,
                  касающихся использования Сайта, оказания услуг, а также обработка запросов и
                  заявок от пользователя.
                </li>
                <li>
                  Заключения, исполнения и прекращения гражданско-правовых договоров с физическими,
                  юридическими лицами, индивидуальными предпринимателями и иными лицами, в случаях,
                  предусмотренных действующим законодательством и/или Уставом предприятия.
                </li>
              </ol>
            </ol>
          </li>
          <li>
            Cookies
            <ol>
              <li>
                Сайт использует Cookies для сбора и хранения фрагментов данных, таких как тип
                браузера, операционная система, ссылочная страница, путь на сайте и т.п. в целях
                получения общей информации об том, как Сайт используется посетителями. Сайт
                использует Cookies в формате, не предполагающем идентификацию личности.
              </li>
              <li>
                Cookie - это небольшие текстовые файлы, иногда содержащие уникальный идентификатор,
                которые сохраняются на жёстком диске пользователя после посещения Сайта. Часть из
                этих файлов сохраняется только на время посещения (Сессии) Пользователем Сайта.
              </li>
              <li>
                При использовании Сайта Вы даёте своё согласие на использование файлов Cookies в
                соответствии с данной Политикой.
              </li>
              <li>
                Если вы не согласны с тем, что Сайт использует Cookies, вам необходимо
                соответствующим образом настроить Ваш браузер, либо отказаться от использования
                Сайта. Вы можете заблокировать обработку Cookies на свои браузерах, в разделах
                "Options (Функции)" или "Preferences (Параметры)" (в зависимости от типа браузера).
                При отключении обработки и записи Cookies, некоторые функции Сайта могут некорректно
                работать.
              </li>
              <li>
                Сайт использует файлы Cookies для аналитики посещаемости Сайта, анализа источников
                интернет-трафика, эффективности рекламы и удобства использования Сайта
                пользователями. Файлы Cookies используются для определения вашего географического
                положения, более точного определения города (для упрощения процедуры входа на Сайт и
                предложения выбора необходимого поддомена), также для автоматического входа в личный
                кабинет Пользователя, если таковой имеется и для корректной работы push-уведомлений.
              </li>
              <li>
                При посещении Сайта на Ваш компьютер могут быть записаны сторонние cookie-файлы,
                которые не контролируются Сайтом. Такие прецеденты возникают при размещении на Сайте
                контента с сайтов 3-й стороны, таких как Youtube, плагинов социальных сетей
                (Вконтакте), инструментов аналитики сторонних компаний (Яндекс.Метрика, google
                analytics). Сайт не может управлять записью и хранением этих cookie. Для того, чтобы
                узнать, с какой целью и как сторонние сервисы используют cookie, Вам необходимо
                ознакомиться с их Политикой конфиденциальности.
              </li>
            </ol>
          </li>
          <li>
            Условия обработки персональной информации пользователя и её передачи третьим лицам
            <ol>
              <li>
                Администрация Сайта хранит персональную информацию пользователей в соответствии с
                внутренними регламентами конкретных сервисов.
              </li>
              <li>
                В отношении персональной информации пользователя сохраняется ее конфиденциальность,
                кроме случаев добровольного предоставления пользователем информации о себе для
                общего доступа неограниченному кругу лиц.
              </li>
              <li>
                Администрация Сайта вправе передать персональную информацию пользователя третьим
                лицам в следующих случаях:
                <ol>
                  <li>
                    Пользователь выразил свое согласие на такие действия, путем согласия
                    выразившегося в предоставлении таких данных;
                  </li>
                  <li>
                    Передача необходима в рамках использования пользователем определенного Сайта,
                    либо для оказания услуги пользователю;
                  </li>
                  <li>
                    Передача предусмотрена российским или иным применимым законодательством в рамках
                    установленной законодательством процедуры;
                  </li>
                  <li>
                    В целях обеспечения возможности защиты прав и законных интересов Администрация
                    Сайта или третьих лиц в случаях, когда пользователь нарушает Пользовательское
                    соглашение Сайта.
                  </li>
                </ol>
              </li>
              <li>
                При обработке персональных данных пользователей Администрация Сайта применяет
                правовые, организационные и технические меры по обеспечению безопасности
                персональных данных в соответствии с Федеральным законом от 27.07.2006 N 152-ФЗ «О
                персональных данных». Администрация Сайта принимает необходимые и достаточные
                организационные и технические меры для защиты персональной информации пользователя
                от неправомерного или случайного доступа, уничтожения, изменения, блокирования,
                копирования, распространения, а также от иных неправомерных действий с ней третьих
                лиц.
              </li>
            </ol>
          </li>
          <li>
            Изменение пользователем персональной информации
            <ol>
              <li>
                Пользователь может в любой момент, отозвать свое согласие на обработку персональных
                данных, оставив заявление в адрес Администрации Сайта: Email:
                <a v-bind:href="$options.supportEmailHref">
                  {{ $options.supportEmailTitle }}
                </a>
                654007, Россия, г. Новокузнецк, пр. Ермакова 11, офис 5.
              </li>
            </ol>
          </li>
          <li>
            Изменение Политики конфиденциальности. Применимое законодательство
            <ol>
              <li>
                Администрация Сайта имеет право вносить изменения в настоящую Политику
                конфиденциальности. При внесении изменений в актуальной редакции указывается дата
                последнего обновления. Новая редакция Политики вступает в силу с момента ее
                размещения, если иное не предусмотрено новой редакцией Политики.
              </li>
              <li>
                К настоящей Политике и отношениям между пользователем и Администрацией Сайта,
                возникающим в связи с применением Политики конфиденциальности, подлежит применению
                право Российской Федерации.
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <footer>
        <div class="container flex">
          <div>2008-{{ currentYear }}© mis.32top.ru</div>
          <router-link class="page__link" v-bind:to="{ name: 'PrivacyPolicy' }">
            Политика конфиденциальности
          </router-link>
        </div>
      </footer>
    </main>
  </div>
</template>
<script>
import RemovableFeature from '@/components/RemovableFeature.vue';
import aboutMixin from '@/mixins/aboutMixin';

/**
 * @description Компонент политики конфиденциальности.
 */
export default {
  components: {
    RemovableFeature,
  },
  data() {
    return {
      currentYear: (new Date()).getFullYear(),
    };
  },
  mixins: [
    aboutMixin,
  ],
  name: 'PrivacyPolicy',
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";
.bg-lightblue {
  background: linear-gradient(180deg, #e2f8ff 53.71%, rgba(213, 237, 255, 0) 100%);
}
h1 {
  font-weight: 700;
  font-size: 45px;
  line-height: 59px;
  margin-bottom: 50px;
}
.page {
  height: 100vh;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  header {
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 163, 255, 0.2);
  }
  &__link, footer > div {
color: #000 !important;
font-weight: 400;
font-size: 14px;
line-height: 16px;
  }
  &__link:hover {
    text-decoration: none;
  }
  &__logo {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 16px;
    color: rgba(40, 49, 67, 0.7);
    gap: 25px;
  }
  &__text {
    margin: 10px;
  }
  &__button {
    @include buttons.btn-blue(160px, 40px, 16px);
    color: white !important;
    text-decoration: none;
  }
  ol {
    counter-reset: li;
    list-style: none;
    padding: 0 0 0 10px;
    margin: 15px 0;
  }
  ol li {
    margin-bottom: 15px;
  }
  ol li::before {
    counter-increment: li;
    content: counters(li, ".") ". ";
  }
  footer {
    border-top: 1px solid #bfdaec;
    padding: 16px 0;
  }
  footer > .flex {
    max-width: 600px;
  }
}
.flex {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
@media screen and (max-width: 768px) {
  .page__logo > div {
    display: none;
  }
}
@media screen and (max-width: 600px) {
  footer > .flex {
    flex-direction: column;
    align-items: start;
    gap: 5px;
  }
}
@media screen and (max-width: 986px) {
  h1 {
    font-size: 38px;
    line-height: 48px;
  }
}
@media screen and (max-width: 768px) {
  h1 {
    font-size: 26px;
    line-height: 30px;
    margin-bottom: 25px;
  }
}

main {
  flex: 1;
  overflow-y: auto;
}
</style>
